import { Controller } from "@hotwired/stimulus"

export default class LandingModules extends Controller {
  static targets = ["nav", "panel", "prevArrow", "nextArrow"]

  connect() {
    this.currentIndex = 0
    this.tabs = this.navTarget.querySelectorAll(".landing-modules__tab")
    this.totalPanels = this.panelTargets.length
    this.autoPlayInterval = null
    this.autoPlayDelay = 8000

    this.startAutoPlay()

    this.element.addEventListener("mouseenter", () => this.stopAutoPlay())
    this.element.addEventListener("mouseleave", () => this.startAutoPlay())
  }

  disconnect() {
    this.stopAutoPlay()
  }

  selectTab(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.showPanel(index)
    this.stopAutoPlay()
  }

  prevTab() {
    const prevIndex =
      this.currentIndex === 0 ? this.totalPanels - 1 : this.currentIndex - 1
    this.showPanel(prevIndex)
    this.stopAutoPlay()
  }

  nextTab() {
    const nextIndex = (this.currentIndex + 1) % this.totalPanels
    this.showPanel(nextIndex)
    this.stopAutoPlay()
  }

  showPanel(index) {
    this.tabs.forEach((tab, i) => {
      tab.classList.toggle("-active", i === index)
    })

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.add("-active")
        this.restartAnimations(panel)
      } else {
        panel.classList.remove("-active")
      }
    })

    this.currentIndex = index
  }

  restartAnimations(panel) {
    const animatedElements = panel.querySelectorAll(
      ".landing-modules__calendar-event, " +
        ".landing-modules__assignment-task, " +
        ".landing-modules__folder-item, " +
        ".landing-modules__part-item, " +
        ".landing-modules__workload-fill",
    )

    animatedElements.forEach(el => {
      el.style.animation = "none"
      // eslint-disable-next-line no-unused-expressions
      el.offsetHeight
      el.style.animation = ""
    })
  }

  startAutoPlay() {
    if (this.autoPlayInterval) return

    this.autoPlayInterval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.totalPanels
      this.showPanel(nextIndex)
    }, this.autoPlayDelay)
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval)
      this.autoPlayInterval = null
    }
  }
}
